import React, { useState } from "react";
import { Box, Button, TextField, Typography, Alert, Paper } from "@mui/material";
import axios from "axios";
import LoginIcon from "@mui/icons-material/Login";

export default function LoginForm({ onLogin }) {
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		setError("");

		const URL = `${process.env.REACT_APP_BACKEND_URL}/api/users/login`;

		try {
			const res = await axios.post(URL, {
				username,
				password,
			});
			localStorage.setItem("token", res.data.token);
			onLogin(res.data.token);
		} catch (err) {
			setError(err.response?.data?.error || "Σφάλμα σύνδεσης. Προσπαθήστε ξανά.");
		}
		setLoading(false);
	};

	return (
		<Box>
			<Paper elevation={3} sx={{ p: 4, minWidth: 320 }}>
				<Typography variant="h5" mb={2} align="center">
					Σύνδεση Χρήστη
				</Typography>
				<form onSubmit={handleSubmit} autoComplete="off">
					<TextField
						label="Όνομα χρήστη"
						value={username}
						onChange={(e) => setUsername(e.target.value)}
						fullWidth
						margin="normal"
						required
						autoComplete="off"
					/>
					<TextField
						label="Κωδικός"
						type="password"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						fullWidth
						margin="normal"
						required
						autoComplete="off"
					/>
					{error && (
						<Alert severity="error" sx={{ mt: 2 }}>
							{error}
						</Alert>
					)}
					<Button
						type="submit"
						variant="contained"
						startIcon={<LoginIcon />}
						fullWidth
						sx={{ mt: 2, background: "#fff", color: "#003375", "&:hover": { background: "#f5f5f5" } }}
						disabled={loading}
					>
						Σύνδεση
					</Button>
				</form>
			</Paper>
		</Box>
	);
}
